import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=31b0d6f0&scoped=true&"
import script from "./Scan.vue?vue&type=script&lang=js&"
export * from "./Scan.vue?vue&type=script&lang=js&"
import style0 from "./Scan.vue?vue&type=style&index=0&id=31b0d6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0d6f0",
  null
  
)

export default component.exports